module.exports = __webpack_public_path__ + "img/contact.1da2c645.jpg";